import React, { useState } from "react";
import SecureLS from "secure-ls";
import axios from "axios";
import Swal from "sweetalert2";
import {
  Box,
  Typography,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import AccountHero from "./AccountHero";
import ChangePasswordDialog from "./ChangePasswordDialog";
import VoucherRedemptionModal from "./VoucherRedemptionModal";
import TitleSetter from "../../component/TitleSetter";

const ls = new SecureLS({ encodingType: "aes" });

const AccountManagement = () => {
  const user = ls.get("user") || {};
  const token = ls.get("authToken") || "";

  const email = user.email || "No Email Available";
  const firstname = user.firstname || "No First Name Available";
  const lastname = user.lastname || "No Last Name Available";
  const companyname = user.companyname || "No Company Name Available";
  const role = user.role || "No Role Available";

  const [pwdOpen, setPwdOpen] = useState(false);
  const [redeemOpen, setRedeemOpen] = useState(false);
  const [backendError, setBackendError] = useState("");

  const handleChangePassword = async (currentPassword, newPassword) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/auth/change-password`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      Swal.fire({ icon: "success", title: "Password Changed" });
      setPwdOpen(false);
      setBackendError("");
    } catch (err) {
      setBackendError(
        err.response?.data?.message || "Failed to change password."
      );
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <TitleSetter title="Account Management" />
      <AccountHero title="Account Management" />

      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableBody>
            {[
              ["Email", email],
              ["First Name", firstname],
              ["Last Name", lastname],
              ["Company Name", companyname],
              ["Role", role],
            ].map(([label, val]) => (
              <TableRow key={label}>
                <TableCell>
                  <Typography variant="h6">{label}</Typography>
                </TableCell>
                <TableCell>{val}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Divider sx={{ my: 4 }} />

      <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
        <Button variant="contained" onClick={() => setPwdOpen(true)}>
          Change Password
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setRedeemOpen(true)}
        >
          Redeem Free Meal
        </Button>
      </Box>

      <ChangePasswordDialog
        open={pwdOpen}
        onClose={() => {
          setPwdOpen(false);
          setBackendError("");
        }}
        onChangePassword={handleChangePassword}
        backendError={backendError}
      />

      <VoucherRedemptionModal
        open={redeemOpen}
        onClose={() => setRedeemOpen(false)}
        reopenModal={() => setRedeemOpen(true)}
      />
    </Box>
  );
};

export default AccountManagement;
